import AddressSelector from 'components/form/AddressSelector/styled';

export default AddressSelector;
